<template>
  <el-dialog
    :visible="visible"
    :width="dialogWidth"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="logout-responsive-css"
    @close="handleCloseLogoutDialog">
    <div class="modal-body">
      <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="64"
          cy="64"
          r="64"
          fill="#FFF5DA" />
        <path
          d="M72.6667 69.5333L80.4 74.0667L78.2667 77.5333L68.6667 71.6667V58.3333H72.6667V69.5333ZM92.6667 69C92.6667 80.76 83.0934 90.3334 71.3334 90.3334C65.9467 90.3334 61.04 88.3067 57.28 85H44.6667C41.6 85 39.3334 82.7333 39.3334 79.6667V55.6667C39.3334 52.68 41.7067 50.44 44.6667 50.3333V49C44.6667 42.36 50.0267 37 56.6667 37C62.9067 37 67.9734 41.7733 68.56 47.88C69.4667 47.7467 70.4 47.6667 71.3334 47.6667C83.0934 47.6667 92.6667 57.24 92.6667 69ZM50 50.3333H63.3334V48.36C63.0134 44.9733 60.1334 42.3333 56.6667 42.3333C52.9867 42.3333 50 45.32 50 49V50.3333ZM87.3334 69C87.3334 60.1733 80.16 53 71.3334 53C62.5067 53 55.3334 60.1733 55.3334 69C55.3334 77.8267 62.5067 85 71.3334 85C80.16 85 87.3334 77.8267 87.3334 69Z"
          fill="#FFB74A" />
      </svg>
      <div class="modal-text">
        <div class="title">
          Cierre de sesión
        </div>
        <div class="text">
          Tu sesión será finalizada en
        </div>
        <div class="text bold">
          {{ timeLeft }} segundos
        </div>
      </div>
      <div class="modal-buttons">
        <div class="btn btn-dark" @click="handleCloseLogoutDialog()">
          Mantener activa
        </div>
        <div class="btn btn-outline" @click="logout()">
          Cerrar sesión
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

//Constantes
const INACTIVITY_TIME = process.env.VUE_APP_INACTIVITY_TIME;
const EXTRA_TIME = process.env.VUE_APP_EXTRA_TIME;
const LOGOUT_STRING = '[LOGOUT]';
const TIMESTAMP_MODAL = 'timestamp_modal';
const EXTRA_TIMESTAMP = 'extra_timestamp';
const LOGOUT_FLAG = 'logout_flag';

export default {
  data(){
    return {
      visible: false,
      interval : null,
      inactivityTime : INACTIVITY_TIME,
      cacheTimeStamp : null,
      time : EXTRA_TIME,
      timeLeft : EXTRA_TIME
    }
  },
  computed : {
    dialogWidth() {
      return this.getWidth() < 768 ? '400' : '200';
    }
  },
  created(){

    //Inicializa el timestamp. Si ya hay una pestaña abierta, sobreescribirá el timestamp de la misma.
    this.setTimeStamp();

    //Va a ir preguntando cada 1 segundo
    this.interval = setInterval(() => {

      //Si el modal se encuentra abierto, va a ir por el flujo del tiempo extra
      if (this.visible){
        this.extraTimeFlux();
        return;
      }

      //De lo contrario, irá por el flujo de tiempo inactivo
      this.inactiveTimeFlux();

    }, 1000);

    //Por último, setea el evento mousemove para que siempre que se mueva el mouse, se resetee el timestamp
    window.addEventListener('mousemove', () => {

      //Si ya esta visible el modal, no hará nada
      if (this.visible){
        return;
      }

      this.setTimeStamp();
    });
  },
  methods : {
    inactiveTimeFlux(){
      //Si la fecha actua es menor a la fecha guardada, no hagas nada
      if (this.getDate() < this.getTimeStamp()){
        return;
      }

      this.cacheTimeStamp = this.getTimeStamp();

      //De lo contrario, desplegaremos el modal
      this.openModal();
    },
    extraTimeFlux(){

      this.resetTimeLeft();

      //Si la fecha actua es menor a la fecha guardada, no hace nada. Todavía le queda tiempo extra al usuario para decidir si quiere quedarse
      if (this.getDate() < this.getTime()){

        //Si ya en otra pestaña el usuario hizo alguna acción que reseteó el timestamp, oculta el modal
        this.visible = this.cacheTimeStamp != this.getTimeStamp() ? false : this.visible;
        return;
      }

      //De lo contrario, bye, bye, amigo
      this.logout();
    },
    getDate(){
      return parseInt(Date.now() / 1000);
    },
    getTimeStamp(){
      //Con esto obtendremos el timestamp del momento exacto en el que debería aparecer el modal
      let timestamp = window.localStorage.getItem(TIMESTAMP_MODAL);
      let logout = window.localStorage.getItem(LOGOUT_FLAG);

      //Aunque no lo creas, no quites este console.log. Por algún motivo, al quitarlo no funciona .______.
      console.log('timer working correctly');

      //Si al obtenerlo, se detecta que otra pestaña ya cerró sesión, adios amigo
      if (logout == LOGOUT_STRING){
        window.location.reload();
      }

      //Lo devuelve sumandole los segundos de inactividad para así saber cuanto tiempo le queda al usuario
      return  parseInt(timestamp) + parseInt(this.inactivityTime);
    },
    setTimeStamp(){
      //Antes de guardar, recuperaremos el timestamp para asegurarnos de no sobreescribirlo en caso de que se haya hecho logout
      this.getTimeStamp();

      //Guardamos la fecha actual en segundos. Esto lo usaremos para verificar
      window.localStorage.setItem(TIMESTAMP_MODAL, this.getDate());
    },
    getTime(){
      //Obtendremos el tiempo extra desde el localstorage
      let extra_timestamp = window.localStorage.getItem(EXTRA_TIMESTAMP);
      return parseInt(extra_timestamp) + parseInt(this.time);
    },
    setTime(){
      //Guardamos la fecha actual en segundos. Esta se usará para el tiempo extra
      window.localStorage.setItem(EXTRA_TIMESTAMP, this.getDate());
    },
    resetTimeLeft(){
      let left = this.getTime() - this.getDate();
      this.timeLeft = left > 0 ? left : 0;
    },
    openModal(){
      this.timeLeft = 60;
      this.visible = true;
      this.setTime();
    },
    logout(){

      //Notificaremos el cierre de sesión en el timestamp para que cualquier otra pestaña abierta tambien fuerce el cierre de sesión
      window.localStorage.setItem(LOGOUT_FLAG, LOGOUT_STRING);

      //Cerrando sesión
      this.$store.dispatch('logout');
    },
    handleCloseLogoutDialog(){
      //Si el usuario decidió quedarse, ocultamos el modal y reseteamos el timestamp.
      this.visible = false;
      this.setTimeStamp();
    },
    getWidth(){
      return document.body.clientWidth;
    }
  }
}
</script>

<style lang="scss">
.modal-body{
  text-align: center;
  .modal-text{
    .bold{
      font-weight: 700;
    }
    .title{
      font-weight: 700;
      font-size: 24px;
    }
    .text{
      font-size: 20px;
    }
  }
  .modal-buttons{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .btn{
    border-radius: 4px;
    margin-top: 12px;
    padding: 12px;
    width: 210px;
    &.btn-dark{
      background: #243952;
      color: white;
    }
    &.btn-outline{
      border: 1px solid #E8343E;
      color: #E8343E;
    }
  }
}

.logout-responsive-css{
    @media (max-width: 500px){
      width: 80% !important;
      margin-top: 10% !important;
    }
  }
</style>
